import { USE_MAINNET } from './networks';

// Contract Addresses
// logic   = GainforceLogic   (user + admin actions only; upgradeable)
// views   = GainforceViews   (all computed read functions)
// storage = GainforceStorage (holds tokens + data; users APPROVE this address)
export const CONTRACT_ADDRESSES = {
  mainnet: {
    logic: '0x88295cd6827429c6765971814Bb8Ca1725A5694e', // TODO: GainforceLogic mainnet address
    views: '0x8e9000f626D44B1a910A62EAF50781E17BEE1721', // TODO: GainforceViews mainnet address
    storage: '0x17A0a6C1770FD7e0859f76f674CC783701ecCd07', // TODO: GainforceStorage mainnet address
    token: '0x55d398326f99059ff775485246999027b3197955'
  },
  testnet: {
    logic: '0x0000000000000000000000000000000000000000', // TODO: GainforceLogic testnet address
    views: '0x0000000000000000000000000000000000000000', // TODO: GainforceViews testnet address
    storage: '0x0000000000000000000000000000000000000000', // TODO: GainforceStorage testnet address
    token: '0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC'
  }
};

export const ACTIVE_CONTRACTS = USE_MAINNET ? CONTRACT_ADDRESSES.mainnet : CONTRACT_ADDRESSES.testnet;

const USER_TUPLE = "tuple(address wallet, uint256 referrerId, uint256 sponsorId, uint8 position, uint256 leftChild, uint256 rightChild, uint256 totalInvestment, uint256 currentPackage, uint256 firstPackage, uint256 leftBusiness, uint256 rightBusiness, uint256 leftBusinessTotal, uint256 rightBusinessTotal, uint256 directReferrals, uint256 teamCount, uint256 directBusiness, uint256 leftDirects, uint256 rightDirects, uint256 binaryMatchedToday, uint256 roiEarned, uint256 binaryEarned, uint256 referralEarned, uint256 roiWithdrawn, uint256 binaryWithdrawn, uint256 referralWithdrawn, uint256 totalWithdrawn, uint256 lastROITimestamp, bool active)";

// GainforceLogic ABI - user actions (no view functions on Logic anymore)
export const LOGIC_ABI = [
  "function registerAndInvest(uint256 sponsorId, uint8 pos, uint256 amount) external",
  "function registerWithPlacement(uint256 sponsorId, uint256 placementId, uint8 pos, uint256 amount) external",
  "function invest(uint256 amount) external",
  "function withdraw(uint256 amount) external"
];

// GainforceViews ABI - computed reads
export const VIEWS_ABI = [
  "function getUserInfo(uint256 uId) external view returns (address wallet, uint256 sponsorId, uint256 referrerId, uint256 totalInvestment, uint256 currentPackage, uint256 firstPackage, bool active)",
  "function getBinaryInfo(uint256 uId) external view returns (uint256 leftChild, uint256 rightChild, uint256 leftBusiness, uint256 rightBusiness, uint256 leftBusinessTotal, uint256 rightBusinessTotal, uint256 leftDirects, uint256 rightDirects, bool hasBinaryElig)",
  "function getIncomeInfo(uint256 uId) external view returns (uint256 totalROI, uint256 totalBinary, uint256 totalReferral, uint256 totalIncome, uint256 totalWithdrawn, uint256 roiWithdrawn, uint256 binaryWithdrawn, uint256 referralWithdrawn)",
  "function getAvailableBreakdown(uint256 uId) external view returns (uint256 availableROI, uint256 availableBinary, uint256 availableReferral, uint256 totalAvailable)",
  "function getDailyBinaryStatus(uint256 uId) external view returns (uint256 dailyCap, uint256 matchedToday, uint256 remainingToday, uint256 nextResetTime)",
  "function getInvestmentDetails(uint256 uId, uint256 idx) external view returns (uint256 amount, uint256 timestamp, uint256 roiEarned, uint256 totalEarned, uint256 cap300, uint256 remaining, bool active, uint8 invType, uint256 lastROITimestamp)",
  "function getROIRate(uint256 uId) external view returns (uint256)",
  "function getRecentActivities(uint256 uId, uint256 count) external view returns (uint256[] amounts, uint256[] timestamps, uint256[] fromIds, uint8[] types)"
];

// GainforceStorage ABI (read-only parts used by the user app)
export const STORAGE_ABI = [
  `function getUser(uint256 uId) external view returns (${USER_TUPLE})`,
  "function getInvestmentCount(uint256 uId) external view returns (uint256)",
  "function getContractBalance() external view returns (uint256)",
  "function addressToId(address) external view returns (uint256)",
  "function totalUsers() external view returns (uint256)",
  "function defaultReferrerId() external view returns (uint256)",
  "function packages(uint256) external view returns (uint256)",
  "function TIME_UNIT() external view returns (uint256)",
  "function minWithdraw() external view returns (uint256)",
  "function withdrawDeduction() external view returns (uint256)",
  "function blacklisted(uint256) external view returns (bool)",
  "function owner() external view returns (address)",
  "function admin() external view returns (address)",

  // Events (emitted by Storage)
  "event UserRegistered(address indexed user, uint256 indexed userId, uint256 indexed sponsorId, uint8 position)",
  "event Invested(uint256 indexed userId, uint256 amount, uint8 invType)",
  "event Withdrawn(uint256 indexed userId, uint256 amount)",
  "event BinaryMatched(uint256 indexed userId, uint256 matched, uint256 income)",
  "event ReferralEarned(uint256 indexed userId, uint256 fromUserId, uint256 amount)",
  "event ROIEarned(uint256 indexed userId, uint256 amount)",
  "event InvestmentCapped(uint256 indexed userId, uint256 indexed investmentIndex)"
];

// ERC20 Token ABI
export const ERC20_ABI = [
  "function name() view returns (string)",
  "function symbol() view returns (string)",
  "function decimals() view returns (uint8)",
  "function balanceOf(address) view returns (uint256)",
  "function allowance(address owner, address spender) view returns (uint256)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function transfer(address to, uint256 amount) returns (bool)"
];

// ============================================
// ADMIN PANEL ABIs (owner / admin only)
// ============================================

// GainforceLogic - admin actions
export const LOGIC_ADMIN_ABI = [
  "function adminRegisterWithId(address wallet, uint256 userId, uint256 sponsorId, uint256 placementId, uint8 pos, uint256 amount) external",
  "function virtualInvest(uint256 uId, uint256 amount) external"
];

// GainforceStorage - admin config reads + writes
// Wallet / fee ids: 1 = team1, 2 = team2, 3 = main, 4 = m  (5 = router, owner screen only)
export const STORAGE_ADMIN_ABI = [
  // Reads
  "function owner() external view returns (address)",
  "function admin() external view returns (address)",
  "function logicContract() external view returns (address)",
  "function token() external view returns (address)",
  "function totalUsers() external view returns (uint256)",
  "function deploymentTime() external view returns (uint256)",
  "function getContractBalance() external view returns (uint256)",
  `function getUser(uint256 uId) external view returns (${USER_TUPLE})`,
  "function getInvestmentCount(uint256 uId) external view returns (uint256)",
  "function addressToId(address) external view returns (uint256)",
  "function usedIds(uint256) external view returns (bool)",
  "function blacklisted(uint256) external view returns (bool)",
  "function defaultReferrerId() external view returns (uint256)",
  "function TIME_UNIT() external view returns (uint256)",
  "function MAX_PROPAGATION_DEPTH() external view returns (uint256)",
  "function MAX_GENERATION_DEPTH() external view returns (uint256)",
  "function baseROI() external view returns (uint256)",
  "function directReferralPercent() external view returns (uint256)",
  "function binaryMatchPercent() external view returns (uint256)",
  "function minWithdraw() external view returns (uint256)",
  "function withdrawDeduction() external view returns (uint256)",
  "function roiThresholds(uint256) external view returns (uint256)",
  "function roiRates(uint256) external view returns (uint256)",
  "function teamWallet1() external view returns (address)",
  "function teamWallet2() external view returns (address)",
  "function mainWallet() external view returns (address)",
  "function mWallet() external view returns (address)",
  "function teamWallet1Percent() external view returns (uint256)",
  "function teamWallet2Percent() external view returns (uint256)",
  "function mainWalletPercent() external view returns (uint256)",
  "function mWalletPercent() external view returns (uint256)",

  // Writes - onlyAdmin
  "function setBlacklist(uint256 uId, bool status) external",
  "function setROIConfig(uint256 _baseROI, uint256[4] _thresholds, uint256[4] _rates) external",
  "function setIncomePercents(uint256 _directRef, uint256 _binaryMatch) external",
  "function setWithdrawConfig(uint256 _minWithdraw, uint256 _deduction) external",
  "function setTimeUnit(uint256 _timeUnit) external",
  "function setMaxDepths(uint256 _prop, uint256 _gen) external",
  "function setWallet(uint8 walletId, address _wallet) external",
  "function setFeePercent(uint8 feeId, uint256 _percent) external",
  "function emergencyWithdraw(uint256 amount) external",

  // Writes - onlyOwner
  "function setAdmin(address _admin) external",
  "function transferOwnership(address newOwner) external",
  "function setLogicContract(address _logic) external"
];

// Router pool - OWNER SCREEN ONLY. Never used for admin or normal users.
export const ROUTER_LOGIC_ABI = [
  "function withdrawRouterPool(uint256 amount, address destination) external"
];

export const ROUTER_STORAGE_ABI = [
  "function routerPool() external view returns (uint256)",
  "function routerPoolEnabled() external view returns (bool)",
  "function routerPoolPercent() external view returns (uint256)",
  "function toggleRouterPool(bool _enabled) external",
  "function setFeePercent(uint8 feeId, uint256 _percent) external"
];

export const ROUTER_FEE_ID = 5;
